
export const errorMessages = {
  required: `The entered e-mail address and/or password is/are incorrect.
    Please enter the correct credentials.`,
  emailField: "The entered e-mail address is incorrect.",
  websiteField: "The website entered is incorrect.",
  passwords: "The password Entered incorrect",
  otp: "Please enter the correct verification code to proceed.",
  terms: "Please accept terms and conditions.",
};